const AUTH_KEY = "findb_auth";
const AUTH_EVENT = "findb-auth-changed";

const decodeBase64Url = (value) => {
  const normalized = String(value || "").replace(/-/g, "+").replace(/_/g, "/");
  const padding = (4 - (normalized.length % 4)) % 4;
  return window.atob(normalized + "=".repeat(padding));
};

const getTokenPayload = (token) => {
  if (!token || typeof token !== "string" || !token.includes(".")) return null;
  try {
    const [encodedPayload] = token.split(".");
    return JSON.parse(decodeBase64Url(encodedPayload));
  } catch {
    return null;
  }
};

const isTokenExpired = (token) => {
  const payload = getTokenPayload(token);
  if (!payload?.exp) return true;
  return Date.now() > Number(payload.exp);
};

const emitAuthChange = () => {
  window.dispatchEvent(new Event(AUTH_EVENT));
};

export const getAuthSession = () => {
  try {
    const raw = localStorage.getItem(AUTH_KEY);
    if (!raw) return null;
    const session = JSON.parse(raw);
    if (isTokenExpired(session?.token)) {
      localStorage.removeItem(AUTH_KEY);
      return null;
    }
    return session;
  } catch {
    return null;
  }
};

export const setAuthSession = (session) => {
  localStorage.setItem(AUTH_KEY, JSON.stringify(session));
  emitAuthChange();
};

export const clearAuthSession = () => {
  localStorage.removeItem(AUTH_KEY);
  emitAuthChange();
};

export const isAuthenticated = () => Boolean(getAuthSession()?.token);

export const setActiveEntityId = (entityId) => {
  const session = getAuthSession();
  if (!session) return;
  setAuthSession({ ...session, entityId: Number(entityId) });
};

export const subscribeToAuthSession = (listener) => {
  window.addEventListener(AUTH_EVENT, listener);
  return () => window.removeEventListener(AUTH_EVENT, listener);
};
